var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _rect, _path4, _path5, _circle5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Digger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#586169",
    d: "M40.123,6.638l6.158,8.831C46.749,16.14,47,16.939,47,17.757V25l-3-3v-4l-6.816-9.871L40.123,6.638z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M40,10h-3l-11,7l-2.171-4.842l12.745-5.943C36.854,6.074,37.163,6,37.477,6H40c0.552,0,1,0.448,1,1v2 C41,9.552,40.552,10,40,10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#586169",
    d: "M27,42H9c-3.314,0-6-2.686-6-6l0,0c0-3.314,2.686-6,6-6h18c3.314,0,6,2.686,6,6l0,0 C33,39.314,30.314,42,27,42z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 36,
    r: 2,
    fill: "#999"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 36,
    r: 2,
    fill: "#999"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 36,
    r: 2,
    fill: "#999"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 36,
    r: 2,
    fill: "#999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 3,
    x: 12,
    y: 27,
    fill: "#e3a600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fad500",
    d: "M21.438,8H14c-1.657,0-3,1.343-3,3v4c0,0.552-0.448,1-1,1H7c-1.657,0-3,1.343-3,3v5 c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3v-5.054c0-0.616-0.189-1.216-0.542-1.72L23.896,9.28C23.334,8.478,22.417,8,21.438,8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a600",
    d: "M18,10h3.809c0.324,0,0.628,0.157,0.816,0.421L28,18v1h-6.027c-0.542,0-0.985-0.431-1-0.973 L20.945,17H18c-1.105,0-2-0.895-2-2v-3C16,10.895,16.895,10,18,10z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 8,
    r: 1,
    fill: "#586169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M44,19c1.657,0,3,1.343,3,3v6c0,1.105-0.895,2-2,2h-6c-1.657,0-3-1.343-3-3l2-1L44,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Digger);
export default __webpack_public_path__ + "static/media/icons8-digger.d94db1a05f601cf69130228fdf57c8ea.svg";
export { ForwardRef as ReactComponent };